export default "__VITE_ASSET__ClclTSgD__"